import * as React from "preact";
import { FunctionComponent } from "preact";

interface IValidation {
  errorMessage: string;
}

const ValidationMessage: FunctionComponent<IValidation> = ({ errorMessage }) => {
  return (
    <div>
      <p>{errorMessage}</p>
    </div>
  );
};

export default ValidationMessage;
